// removed by extract-text-webpack-plugin
module.exports = {"root":"checkbox-group--root--kDvd09Wc"};


//////////////////
// WEBPACK FOOTER
// ./components/forms/checkbox-group/styles.css
// module id = ./components/forms/checkbox-group/styles.css
// module chunks = 0